// Volume needed (L) = area m² × depth cm × 10. Recommends bag count for the largest bag size.
(function () {
  document.querySelectorAll('[data-tv-calculator]').forEach(function (el) {
    var sizes = (el.dataset.bagSizes || '')
      .split(',').map(function (s) { return parseFloat(s); })
      .filter(function (n) { return !isNaN(n) && n > 0; });
    if (!sizes.length) return;
    var bag = Math.max.apply(null, sizes);
    var area = el.querySelector('[data-tv-area]');
    var depth = el.querySelector('[data-tv-depth]');
    var out = el.querySelector('[data-tv-result]');
    var bagsLabel = el.dataset.bagsLabel || 'bags';
    function update() {
      var litres = (parseFloat(area.value) || 0) * (parseFloat(depth.value) || 0) * 10;
      var bags = Math.ceil(litres / bag);
      out.textContent = litres > 0 ? '≈ ' + bags + ' ' + bagsLabel + ' (' + bag + ' L)' : '';
    }
    area.addEventListener('input', update);
    depth.addEventListener('input', update);
    update();
  });
})();
